import { render, staticRenderFns } from "./initial-left-column.vue?vue&type=template&id=caa1172a&scoped=true&"
import script from "./initial-left-column.vue?vue&type=script&lang=ts&"
export * from "./initial-left-column.vue?vue&type=script&lang=ts&"
import style0 from "./initial-left-column.vue?vue&type=style&index=0&id=caa1172a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa1172a",
  null
  
)

export default component.exports